// src/components/Header.js
import React from 'react';
import './Header.css';
import profileImage from '../assets/profile.jpg';

const Header = () => {
  return (
    <header className="header">
      <img src={profileImage} alt="Prathviraj Singh" className="profile-image " />
      <h1 className="name">Prathviraj Singh</h1>
      <h2 className="title">Data Scientist | Machine Learning Engineer</h2>
    </header>
  );
};

export default Header;
